import { useState, useCallback, useEffect } from 'react'

// Estado global simples para CVV temporário
let globalTemporaryCvv: { [cardId: string]: string } = {}
const globalSetters: Set<(cvv: { [cardId: string]: string }) => void> = new Set()

const notifyAllSetters = (newCvv: { [cardId: string]: string }) => {
  globalSetters.forEach((setter) => setter(newCvv))
}

export const useTemporaryCvv = () => {
  const [temporaryCvv, setTemporaryCvv] = useState<{ [cardId: string]: string }>(globalTemporaryCvv)

  const setCvv = useCallback(
    (cvv: { [cardId: string]: string } | ((prev: { [cardId: string]: string }) => { [cardId: string]: string })) => {
      const newCvv = typeof cvv === 'function' ? cvv(globalTemporaryCvv) : cvv
      globalTemporaryCvv = newCvv
      notifyAllSetters(newCvv)
    },
    []
  )

  const clearCvv = useCallback((cardId: string) => {
    const newCvv = { ...globalTemporaryCvv }
    delete newCvv[cardId]
    globalTemporaryCvv = newCvv
    notifyAllSetters(newCvv)
  }, [])

  const clearAllCvv = useCallback(() => {
    globalTemporaryCvv = {}
    notifyAllSetters({})
  }, [])

  // Registrar este componente para receber atualizações
  useEffect(() => {
    const setter = (newCvv: { [cardId: string]: string }) => {
      setTemporaryCvv(newCvv)
    }
    globalSetters.add(setter)

    return () => {
      globalSetters.delete(setter)
    }
  }, [])

  return {
    temporaryCvv,
    setTemporaryCvv: setCvv,
    clearCvv,
    clearAllCvv
  }
}
